import React, {Component} from 'react';
import './Partners.css'

class Partners extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        return (
            <div></div>
        );
    }
}

export default Partners;


// WEBPACK FOOTER //
// ./src/pages/Partners/Partners.js